module.exports = __webpack_public_path__ + "img/classroom_img.f18164cb.png";